import { useState, useEffect } from 'react';

const API_URL = 'https://nwt.am';

export default function AdminPosts() {
    const [deleteId, setDeleteId] = useState(null);
    const [posts, setPosts] = useState([]);
    const [editingPost, setEditingPost] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [form, setForm] = useState({
        title_arm: '', title_eng: '', title_ru: '',
        desc_arm: '', desc_eng: '', desc_ru: '',
        content_arm: '', content_eng: '', content_ru: '',
        image: '', category: 'general', status: 'published'
    });

    useEffect(() => {
        loadPosts();
    }, []);

    const loadPosts = async () => {
        try {
            const res = await fetch(`${API_URL}/posts.php?admin=1`);
            const data = await res.json();
            setPosts(Array.isArray(data) ? data : []);
        } catch (err) {
            setPosts([]);
        }
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);

        const formData = new FormData();
        formData.append('image', file);

        try {
            const res = await fetch(`${API_URL}/upload.php`, {
                method: 'POST',
                body: formData,
            });
            const data = await res.json();

            if (data.success && data.url) {
                setForm({ ...form, image: data.url });
            } else {
                alert('Upload failed: ' + (data.message || 'Unknown error'));
            }
        } catch (err) {
            console.error('Upload error:', err);
            alert('Upload error. Check console.');
        } finally {
            setUploading(false);
            e.target.value = '';
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = editingPost ? `${API_URL}/posts.php?id=${editingPost.id}` : `${API_URL}/posts.php`;
        const method = editingPost ? 'PUT' : 'POST';

        await fetch(url, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form)
        });

        setShowForm(false);
        setEditingPost(null);
        setForm({ 
            title_arm: '', title_eng: '', title_ru: '', 
            desc_arm: '', desc_eng: '', desc_ru: '',
            content_arm: '', content_eng: '', content_ru: '',
            image: '', category: 'general', status: 'published' 
        });
        setTimeout(() => loadPosts(), 300);
    };

    const editPost = (post) => {
        setEditingPost(post);
        setForm({
            title_arm: post.title_arm || '', title_eng: post.title_eng || '', title_ru: post.title_ru || '',
            desc_arm: post.desc_arm || '', desc_eng: post.desc_eng || '', desc_ru: post.desc_ru || '',
            content_arm: post.content_arm || '', content_eng: post.content_eng || '', content_ru: post.content_ru || '',
            image: post.image || '', category: post.category || 'general', status: post.status || 'published'
        });
        setShowForm(true);
    };

    const handleDelete = async () => {
        await fetch(`${API_URL}/posts.php?id=${deleteId}`, { method: 'DELETE' });
        setDeleteId(null);
        setTimeout(() => loadPosts(), 300);
    };

    return (
        <div>
            <div className="flex items-center justify-between mb-8">
                <h1 className="text-3xl font-black text-[#0B3B6F] uppercase">Նորություններ</h1>
                <button
                    onClick={() => { setEditingPost(null); setShowForm(!showForm); }}
                    className="px-6 py-3 bg-[#0FA4E8] text-white font-bold uppercase tracking-wider text-sm hover:bg-[#0B3B6F] transition-colors"
                >
                    + Նոր գրառում
                </button>
            </div>

            {/* Форма */}
            {showForm && (
                <form onSubmit={handleSubmit} className="bg-white border border-gray-200 p-6 mb-8 space-y-6">
                    <h3 className="text-lg font-bold text-[#0B3B6F] uppercase">
                        {editingPost ? 'Խմբագրել գրառումը' : 'Նոր գրառում'}
                    </h3>
                    
                    {/* Заголовки */}
                    <div>
                        <h4 className="text-sm font-bold text-[#0FA4E8] uppercase mb-2">Վերնագրեր</h4>
                        <div className="grid gap-4 md:grid-cols-3">
                            <input type="text" placeholder="Վերնագիր (ARM) *" required value={form.title_arm}
                                onChange={(e) => setForm({...form, title_arm: e.target.value})}
                                className="border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                            <input type="text" placeholder="Title (ENG)" value={form.title_eng}
                                onChange={(e) => setForm({...form, title_eng: e.target.value})}
                                className="border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                            <input type="text" placeholder="Заголовок (RU)" value={form.title_ru}
                                onChange={(e) => setForm({...form, title_ru: e.target.value})}
                                className="border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                        </div>
                    </div>

                    {/* Краткое описание */}
                    <div>
                        <h4 className="text-sm font-bold text-[#0FA4E8] uppercase mb-2">Կարճ նկարագրություն</h4>
                        <div className="grid gap-4 md:grid-cols-3">
                            <textarea placeholder="Նկարագրություն (ARM)" value={form.desc_arm}
                                onChange={(e) => setForm({...form, desc_arm: e.target.value})}
                                rows="3" className="border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                            <textarea placeholder="Description (ENG)" value={form.desc_eng}
                                onChange={(e) => setForm({...form, desc_eng: e.target.value})}
                                rows="3" className="border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                            <textarea placeholder="Описание (RU)" value={form.desc_ru}
                                onChange={(e) => setForm({...form, desc_ru: e.target.value})}
                                rows="3" className="border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                        </div>
                    </div>

                    {/* Полный текст */}
                    <div>
                        <h4 className="text-sm font-bold text-[#0FA4E8] uppercase mb-2">Ամբողջական տեքստ</h4>
                        <div className="grid gap-4 md:grid-cols-3">
                            <textarea placeholder="Ամբողջական տեքստ (ARM)" value={form.content_arm}
                                onChange={(e) => setForm({...form, content_arm: e.target.value})}
                                rows="6" className="border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                            <textarea placeholder="Full text (ENG)" value={form.content_eng}
                                onChange={(e) => setForm({...form, content_eng: e.target.value})}
                                rows="6" className="border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                            <textarea placeholder="Полный текст (RU)" value={form.content_ru}
                                onChange={(e) => setForm({...form, content_ru: e.target.value})}
                                rows="6" className="border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                        </div>
                    </div>

                    {/* Изображение */}
                    <div className="grid gap-4 md:grid-cols-2">
                        <div>
                            <label className="block text-xs font-bold text-[#0B3B6F] uppercase mb-1">Նկարի URL</label>
                            <input type="text" placeholder="https://..." value={form.image}
                                onChange={(e) => setForm({...form, image: e.target.value})}
                                className="w-full border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none" />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-[#0B3B6F] uppercase mb-1">Կամ ներբեռնել ֆայլ</label>
                            <input 
                                type="file" 
                                accept="image/*"
                                onChange={handleFileUpload}
                                disabled={uploading}
                                className="block w-full text-sm text-slate-500 file:mr-4 file:py-2.5 file:px-4 file:border-0 file:text-sm file:font-bold file:bg-[#0FA4E8] file:text-white hover:file:bg-[#0B3B6F] file:transition-colors file:cursor-pointer disabled:opacity-50"
                            />
                            {uploading && <p className="text-xs text-[#0FA4E8] mt-1">Վերբեռնում...</p>}
                        </div>
                    </div>

                    {/* Превью */}
                    {form.image && (
                        <div className="w-40 h-24 overflow-hidden border border-gray-200">
                            <img src={form.image} alt="preview" className="w-full h-full object-cover" />
                        </div>
                    )}

                    <div className="flex gap-4 items-end">
                        <div className="w-40">
                            <label className="block text-xs font-bold text-[#0B3B6F] uppercase mb-1">Կարգավիճակ</label>
                            <select value={form.status}
                                onChange={(e) => setForm({...form, status: e.target.value})}
                                className="w-full border border-gray-200 px-3 py-2.5 text-sm focus:border-[#0FA4E8] focus:outline-none">
                                <option value="published">Տեղադրվել է</option>
                                <option value="draft">Draft</option>
                            </select>
                        </div>
                        <button type="submit" className="px-8 py-2.5 bg-[#0B3B6F] text-white font-bold uppercase text-sm hover:bg-[#0FA4E8] transition-colors">
                            Պահպանել
                        </button>
                        <button type="button" onClick={() => setShowForm(false)} className="px-6 py-2.5 border border-gray-200 text-sm font-bold uppercase hover:bg-gray-50">
                            Չեղարկել
                        </button>
                    </div>
                </form>
            )}

            {/* Список постов */}
            <div className="grid gap-4">
                {posts.map((post) => (
                    <div key={post.id} className="flex gap-4 bg-white border border-gray-100 hover:border-[#0FA4E8]/30 transition-all p-2 group">
                        <div className="w-24 h-16 flex-shrink-0 overflow-hidden border border-gray-100">
                            {post.image ? (
                                <img src={post.image} alt="" className="w-full h-full rounded-none object-cover" />
                            ) : (
                                <div className="w-full h-full bg-gray-50 flex items-center justify-center text-gray-300 text-xs">no img</div>
                            )}
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="font-bold text-[#0B3B6F] truncate">{post.title_arm}</h3>
                            <div className="flex gap-3 mt-1">
                                <span className="text-xs text-slate-400">EN: {post.title_eng?.substring(0, 40)}</span>
                                <span className="text-xs text-slate-400">RU: {post.title_ru?.substring(0, 40)}</span>
                            </div>
                            <p className="text-xs text-slate-400 mt-1">
                                {post.category} | <span className={post.status === 'published' ? 'text-green-500' : 'text-orange-400'}>{post.status}</span> | {post.created_at?.substring(0, 10)}
                            </p>
                        </div>
                        <div className="flex items-center gap-2 flex-shrink-0">
                            <button onClick={() => editPost(post)} className="px-3 py-1.5 text-xs font-bold text-[#0FA4E8] hover:bg-[#0FA4E8]/10 transition-colors uppercase">Խմբագրել</button>
                            <button onClick={() => setDeleteId(post.id)} className="px-3 py-1.5 text-xs font-bold text-red-500 hover:bg-red-50 transition-colors uppercase">Ջնջել</button>
                        </div>
                    </div>
                ))}
                {posts.length === 0 && (
                    <p className="text-center text-slate-400 py-12">Դեռևս գրառումներ չկան</p>
                )}
            </div>

            {/* Модалка удаления */}
            {deleteId && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                    <div className="bg-white p-6 shadow-lg max-w-sm w-full">
                        <p className="text-sm font-bold text-[#0B3B6F] mb-4">Ջնջե՞լ գրառումը</p>
                        <div className="flex gap-2 justify-end">
                            <button onClick={handleDelete} className="px-4 py-2 bg-red-500 text-white text-xs font-bold uppercase hover:bg-red-600">Ջնջել</button>
                            <button onClick={() => setDeleteId(null)} className="px-4 py-2 bg-gray-200 text-xs font-bold uppercase hover:bg-gray-300">Չեղարկել</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}